import { GetterTree } from 'vuex'
import { IRootState, FeatureFlagsState } from '@/@types'

const getters: GetterTree<FeatureFlagsState, IRootState> = {
  getIsBooGoPromoActive: state => {
    return state?.flags?.isBooGoPromoActive
  },
  getRunningBlackFriday: state => {
    return state?.flags?.runningBlackFriday
  },
  isBlackFridayActive: state => {
    const timestamp = state?.flags?.runningBlackFriday
    if (timestamp === 0) {
      return false
    }
    const now = new Date().getTime()
    return now > timestamp
  },
  getIsLeapYearPromoActive: state => {
    return state?.flags?.runningPromotions
  },
  isLeapYearPromoActive: state => {
    const timestamp = Number(state?.flags?.runningPromotions)
    if (timestamp === 0) {
      return false
    }
    const now = new Date().getTime()
    return now > timestamp
  },
}

export default getters
